import React from "react";
import "../../assets/scss/intel.scss";
import "../../assets/scss/global.scss";
import SankeyDiagram from "../../core/charts/sankey-diagram";
import ImporterExporterGraphTop from "./importer-exporter-top";
import axios from "axios";
import Pagination from "react-bootstrap/Pagination";
import { toast } from "react-toastify";
import NoSearchDataComponent from "./no-search-data";
import commaFormat from "../../utils/commaFormat";
import LoaderImg from "../../../src/assets/images/loader.gif";

export default class ImporterExporterGraph extends React.Component {
  uniqueImpExpApi = {
    renderImpExpGraph: this.props.impExpGraphDataApi,
  };
  constructor(props) {
    super(props);
    this.state = {
      sankeyDiagram: { data: [] },
      mustNot: [],
      currentPage: 1,
      resultPerPage: 10,
      isLoader: null,
      totalCount: props.totalCount,
      isInternalFilterApplied: props.isInternalFilterApplied,
      levelOneArr: [],
      levelTwoArr: [],
      sortValue: !!props && !!props.searchReqObj && !!props.searchReqObj.sort && props.searchReqObj.sort === "date" ? "Shipments" : props.searchReqObj.sort === "weight" ? "Weight" : props.searchReqObj.sort === "shipment_value" ? "Value" : "TEU",
    };
  }
  handlePageChange(e) {
    this.setState({
      isLoader: true,
    });
    if (!!this && !!this.state && !!this.state.isInternalFilterApplied && this.state.isInternalFilterApplied === true) {
      if (!!e && e === "next") {
        this.setState({
          sankeyDiagram: { data: [] },
        });
        setTimeout(() => {
          this.mapIsAppliedFilterData(this.state.currentPage + 1);
          this.setState({
            currentPage: this.state.currentPage + 1,
          });
        }, 200);
      } else if (!!e && e === "prev") {
        this.setState({
          sankeyDiagram: { data: [] },
        });
        setTimeout(() => {
          this.mapIsAppliedFilterData(this.state.currentPage - 1);
          this.setState({
            currentPage: this.state.currentPage - 1,
          });
        }, 200);
      }
    } else {
      if (!!e && e === "next") {
        this.setState({
          currentPage: this.state.currentPage + 1,
          sankeyDiagram: { data: [] },
        });
        this.callGraphApi();
      } else if (!!e && e === "prev") {
        this.setState({
          currentPage: this.state.currentPage - 1,
          sankeyDiagram: { data: [] },
          mustNot: this.state.mustNot.slice(0, (this.state.currentPage - 2) * this.state.resultPerPage),
        });
        setTimeout(() => {
          this.callGraphApi();
        }, 200);
      }
    }
  }
  convertToStandardName = (data) => {
    return data.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
  };
  // below method is used to map the Sankey Diagram Data
  mapSankeyData(data) {
    let tempData = data;
    data.map((dataObj, index) => {
      if (dataObj) {
        tempData[index].from = this.convertToStandardName(data[index].from);
        tempData[index].to = this.convertToStandardName(data[index].to);
        tempData[index].tooltipText = this.mapTooltipText(data[index]);
      }
    });
    const sankeyDiagramData = { data: tempData };
    this.setState({
      sankeyDiagram: sankeyDiagramData,
      isLoader: false,
    });
  }
  // End of the above code
  // below code is for mapping the Tooltip text
  mapTooltipText(data) {
    let tempStr = "";
    let strFrom = data.from.split("#");
    let strTo = data.to.split("#");
    if (this.props.type.toUpperCase() === "EXPORTER") {
      tempStr = data.level === 1 ? strFrom[0] + " ← " + strTo[0] + "\n" + this.state.sortValue + ": " + commaFormat(data.value.toFixed(2)) + (!!this.state.sortValue && this.state.sortValue === "Weight" ? " Kgs" : "") + (data.marketShare ? " | " + " Market Share: " + parseFloat(data.marketShare.slice(0, -2)).toFixed(2) + "%" : "") : strFrom[0] + " → " + strTo[0] + "\n" + this.state.sortValue + ": " + commaFormat(data.value.toFixed(2)) + (!!this.state.sortValue && this.state.sortValue === "Weight" ? " Kgs" : "") + (data.marketShare ? " | " + " Market Share: " + parseFloat(data.marketShare.slice(0, -2)).toFixed(2) + "%" : !!this.state.sortValue && this.state.sortValue === "Value" ? "USD" : "");
    } else {
      tempStr = data.level === 1 ? strFrom[0] + " → " + strTo[0] + "\n" + this.state.sortValue + ": " + commaFormat(data.value.toFixed(2)) + (!!this.state.sortValue && this.state.sortValue === "Weight" ? " Kgs" : "") + (data.marketShare ? " | " + " Market Share: " + parseFloat(data.marketShare.slice(0, -2)).toFixed(2) + "%" : "") : strFrom[0] + " ← " + strTo[0] + "\n" + this.state.sortValue + ": " + commaFormat(data.value.toFixed(2)) + (!!this.state.sortValue && this.state.sortValue === "Weight" ? " Kgs" : "") + (data.marketShare ? " | " + " Market Share: " + parseFloat(data.marketShare.slice(0, -2)).toFixed(2) + "%" : !!this.state.sortValue && this.state.sortValue === "Value" ? "USD" : "");
    }
    return tempStr;
  }
  // End of the above code
  // Below code is for mapping the Is Filter Applied Data
  mapIsAppliedFilterData(pageNumber) {
    const startValue = (pageNumber - 1) * 10;
    const endValue = this.state.totalCount <= pageNumber * 10 ? this.state.totalCount : pageNumber * 10;
    let tempLevel1Arr = [...this.state.levelOneArr];
    let tempLevel2Arr = [...this.state.levelTwoArr];
    let tempArr1 = [];
    let tempArr2 = [];
    let tempFinalArr = [];
    for (let i = startValue; i < endValue; i++) {
      if (!!tempLevel1Arr[i] && tempLevel1Arr[i] !== "") {
        tempArr1.push(tempLevel1Arr[i]);
      }
    }
    for (let i = 0; i < tempLevel2Arr.length; i++) {
      for (let j = 0; j < tempArr1.length; j++) {
        if (!!tempArr1[j] && !!tempLevel2Arr[i] && !!tempArr1[j].to && !!tempLevel2Arr[i].from && tempArr1[j].to !== "" && tempLevel2Arr[i].from !== "" && tempArr1[j].to === tempLevel2Arr[i].from) {
          tempArr2.push(tempLevel2Arr[i]);
        }
      }
    }
    const finalOutput = tempFinalArr.concat(tempArr1, tempArr2);
    this.mapSankeyData(finalOutput);
  }
  // End of the above code
  callGraphApi() {
    this.setState({
      isLoader: true,
    });
    let reqObj = this.props.searchReqObj ? { ...this.props.searchReqObj } : {};
    reqObj.isGraph = true;
    reqObj.must_not = this.state.mustNot;
    reqObj.uniqueImportExporterShipment = !!this.props.uniqueImportExporterShipment && this.props.uniqueImportExporterShipment.length > 0 ? this.props.uniqueImportExporterShipment : [];
    reqObj.uniqueImportExporterWeight = !!this.props.uniqueImportExporterWeight && this.props.uniqueImportExporterWeight.length > 0 ? this.props.uniqueImportExporterWeight : [];
    reqObj.uniqueImportExporterTeu = !!this.props.uniqueImportExporterTeu && this.props.uniqueImportExporterTeu.length > 0 ? this.props.uniqueImportExporterTeu : [];
    reqObj.uniqueImportExporterValue = !!this.props.uniqueImportExporterValue && this.props.uniqueImportExporterValue.length > 0 ? this.props.uniqueImportExporterValue : [];
    reqObj.companyType = !!this.props.type && this.props.type === "IMPORTER" ? "consignee" : "shipper";
    axios.post(this.uniqueImpExpApi.renderImpExpGraph, reqObj).then((res) => {
      if (!!res && !!res.data && !!res.data.data) {
        if (!!this && !!this.state && !!this.state.isInternalFilterApplied && this.state.isInternalFilterApplied === true) {
          let tempLevel1Arr = [];
          let tempLevel2Arr = [];
          for (let i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].level === 1) {
              tempLevel1Arr.push(res.data.data[i]);
            }
            if (res.data.data[i].level === 2) {
              tempLevel2Arr.push(res.data.data[i]);
            }
          }
          this.setState({
            levelOneArr: tempLevel1Arr,
            levelTwoArr: tempLevel2Arr,
            totalCount: tempLevel1Arr.length,
          });
          setTimeout(() => {
            this.mapIsAppliedFilterData(1);
          }, 100);
        } else {
          this.mapSankeyData(res.data.data);
        }
      } else {
        toast.error("Something went wrong. Please try again12212!!!");
      }
      if (!!res && !!res.data && !!res.data.must_not && res.data.must_not.length > 0) {
        let tempArr = [...this.state.mustNot];
        let updatedMustNot = tempArr.concat(res.data.must_not);
        this.setState({ mustNot: updatedMustNot });
      }
    });
  }
  componentDidMount() {
    this.callGraphApi();
  }
  render() {
    return this.state.isLoader ? (
      <div className="loader-container">
        <div className="loader-block">
          <img src={LoaderImg} alt="description of gif" />
        </div>
      </div>
    ) : (
      <div className={`importer-exporter-graph-container ${this.state.sankeyDiagram.data.length > 0 ? null : "d-flex justify-content-center align-items-center"}`}>
        {this.state.sankeyDiagram.data.length > 0 ? (
          <div>
            <ImporterExporterGraphTop value={this.props.type}></ImporterExporterGraphTop>
            <SankeyDiagram data={this.state.sankeyDiagram}></SankeyDiagram>
            {!!this && !!this.state && !!this.state.totalCount && this.state.totalCount !== "" ? (
              <div className="d-flex justify-content-center align-items-center mt-2">
                <span>
                  Showing {this.state.currentPage * this.state.resultPerPage - (this.state.resultPerPage - 1)}-{this.state.currentPage * this.state.resultPerPage < this.state.totalCount ? this.state.currentPage * this.state.resultPerPage : this.state.totalCount} of
                </span>
                <span>
                  <Pagination>
                    <Pagination.Item className="page-item pagination-item">{this.state.totalCount}</Pagination.Item>
                    {!(this.state.currentPage * this.state.resultPerPage >= this.state.totalCount && this.state.currentPage === 1) ? (
                      <>
                        <Pagination.Prev disabled={this.state.currentPage === 1 ? true : false} className="page-item pagination-prev" onClick={() => this.handlePageChange("prev")} />
                        <Pagination.Next disabled={this.state.currentPage * this.state.resultPerPage >= this.state.totalCount ? true : false} className="page-item pagination-next" onClick={() => this.handlePageChange("next")} />
                      </>
                    ) : (
                      <></>
                    )}
                  </Pagination>
                </span>
              </div>
            ) : (
              <></>
            )}
          </div>
        ) : this.state.sankeyDiagram.data.length === 0 ? (
          <NoSearchDataComponent content={`No Unique ${this.props.type === "EXPORTER" ? "Exporter" : "Importer"} Found`} />
        ) : (
          <></>
        )}
      </div>
    );
  }
}
